var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "graduateDefense" },
    [
      _c("div", { staticClass: "cont-box" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _c("Title", { attrs: { text: "毕业设计及答辩" } }),
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "search",
                    staticClass: "search-form",
                    attrs: {
                      slot: "search",
                      inline: true,
                      model: _vm.condition,
                      rules: _vm.searchRules,
                      "label-width": "80px",
                    },
                    slot: "search",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c("div", [
                          _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "paper_plan_id" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "300px" },
                                      attrs: {
                                        placeholder: "请选择论文计划",
                                        clearable: "",
                                        filterable: "",
                                      },
                                      model: {
                                        value: _vm.condition.paper_plan_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.condition,
                                            "paper_plan_id",
                                            $$v
                                          )
                                        },
                                        expression: "condition.paper_plan_id",
                                      },
                                    },
                                    _vm._l(_vm.thesisPlanList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.title,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.loadData },
                                    },
                                    [_vm._v("确认")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("div"),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm.isShowTble
          ? _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.list,
                      headerRowClassName: "uni-primary-table-header",
                      stripe: "",
                      border: "",
                      "span-method": _vm.tableSpanMethod,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "stepName",
                        align: "center",
                        label: "步骤",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "process",
                        align: "center",
                        label: "流程环节",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "week", align: "center", label: "周次" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "deadline",
                        align: "center",
                        label: "截止时间",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "操作", width: "240" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row, $index }) {
                              return [
                                $index == 0
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "link-btn",
                                            attrs: {
                                              disabled:
                                                _vm.studentInfo.is_sign == 1 ||
                                                _vm.studentInfo.step != 1,
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.graduationRegistrationClick(
                                                  row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("毕设报名 ")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              disabled: _vm.studentInfo
                                                .files_url
                                                ? false
                                                : true,
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.taskTitleClick(row)
                                              },
                                            },
                                          },
                                          [_vm._v("下载任务书 ")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                $index == 1
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "link-btn",
                                              attrs: {
                                                disabled:
                                                  _vm.studentInfo
                                                    .is_declaration == 1 ||
                                                  _vm.studentInfo.step != 2,
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.seeInstructor(row)
                                                },
                                              },
                                            },
                                            [_vm._v("查看指导老师 ")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "link-btn",
                                              attrs: {
                                                disabled:
                                                  _vm.studentInfo.step <= 2,
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.isShowSeeInstructorLook = true
                                                },
                                              },
                                            },
                                            [_vm._v("查看 ")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "link-btn",
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.proposalClick(row)
                                                },
                                              },
                                            },
                                            [_vm._v("开题报告 ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                $index == 2
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "link-btn",
                                            attrs: {
                                              disabled:
                                                _vm.studentInfo.is_one == 1 ||
                                                _vm.studentInfo.step != 5,
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.designDataClick(1)
                                              },
                                            },
                                          },
                                          [_vm._v(" 一稿上传 ")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "link-btn",
                                            attrs: {
                                              disabled:
                                                _vm.studentInfo.is_one == 0 &&
                                                _vm.studentInfo.step <= 5,
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.seeDesignDataClick(1)
                                              },
                                            },
                                          },
                                          [_vm._v("查看")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                $index == 3
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "link-btn",
                                            attrs: {
                                              disabled:
                                                _vm.studentInfo.is_two == 1 ||
                                                _vm.studentInfo.step != 6,
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.designDataClick(2)
                                              },
                                            },
                                          },
                                          [_vm._v(" 二稿上传 ")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "link-btn",
                                            attrs: {
                                              disabled:
                                                _vm.studentInfo.is_two == 0 &&
                                                _vm.studentInfo.step <= 6,
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.seeDesignDataClick(2)
                                              },
                                            },
                                          },
                                          [_vm._v("查看")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                $index == 4
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "link-btn",
                                            attrs: {
                                              disabled:
                                                _vm.studentInfo.is_three == 1,
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.designDataClick(3)
                                              },
                                            },
                                          },
                                          [_vm._v(" 三稿上传 ")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "link-btn",
                                            attrs: {
                                              disabled:
                                                _vm.studentInfo.is_three == 0 &&
                                                _vm.studentInfo.step <= 7,
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.seeDesignDataClick(3)
                                              },
                                            },
                                          },
                                          [_vm._v("查看")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                $index == 5
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "link-btn",
                                            attrs: {
                                              disabled:
                                                _vm.studentInfo.is_three == 0,
                                              type: "text",
                                            },
                                            on: {
                                              click:
                                                _vm.defenseApplicationClick,
                                            },
                                          },
                                          [_vm._v("答辩申请 ")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                $index == 7
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "link-btn",
                                            attrs: {
                                              disabled:
                                                _vm.studentInfo.process_status <
                                                5,
                                              type: "text",
                                            },
                                            on: {
                                              click: _vm.submitApplicationClick,
                                            },
                                          },
                                          [_vm._v("提交申请 ")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1250846958
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "graduationRegistration",
          attrs: {
            title: "毕业设计论文及答辩报名说明文件",
            visible: _vm.isShowGraduationRegistration,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowGraduationRegistration = $event
            },
            close: _vm.graduationRegistrationClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "cont" },
            [
              _c(
                "div",
                {
                  staticClass: "text-box",
                  staticStyle: {
                    border: "1px solid #ccc",
                    padding: "10px 0 10px 10px",
                  },
                },
                [
                  _c(
                    "el-scrollbar",
                    {
                      ref: "graduationRegistrationScrollbar",
                      staticStyle: { height: "500px" },
                    },
                    [
                      _c("pdf", {
                        attrs: { src: _vm.pdfUrl, page: _vm.pdfCurrPage },
                        on: { "num-pages": _vm.numPagesFun },
                      }),
                      _c(
                        "div",
                        { staticClass: "page-box" },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v("第 " + _vm._s(_vm.pdfCurrPage) + " 页"),
                          ]),
                          _c("span", { staticClass: "text" }, [
                            _vm._v("总页数：" + _vm._s(_vm.pdfPageTotal)),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                disabled: _vm.pdfCurrPage <= 1,
                              },
                              on: { click: _vm.pdfPrev },
                            },
                            [_vm._v("上一页")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                disabled: _vm.pdfCurrPage >= _vm.pdfPageTotal,
                              },
                              on: { click: _vm.pdfNext },
                            },
                            [_vm._v("下一页 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "graduationRegistrationRef",
                  staticStyle: { "margin-top": "10px" },
                  attrs: {
                    model: _vm.graduationRegistrationData,
                    rules: _vm.graduationRegistrationRules,
                    "label-width": "160px",
                    "label-position": "left",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "200px" },
                          attrs: {
                            label: "",
                            prop: "is_read",
                            "label-width": "0",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { "true-label": 1, "false-label": "" },
                              model: {
                                value: _vm.graduationRegistrationData.is_read,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.graduationRegistrationData,
                                    "is_read",
                                    $$v
                                  )
                                },
                                expression:
                                  "graduationRegistrationData.is_read",
                              },
                            },
                            [_vm._v("我已阅读 ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "手写签名:",
                            prop: "student_sign_img",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c("esignHandle", {
                            ref: "esignHandle",
                            attrs: {
                              selectSignImg:
                                _vm.graduationRegistrationData.student_sign_img,
                            },
                            on: {
                              "update:selectSignImg": function ($event) {
                                return _vm.$set(
                                  _vm.graduationRegistrationData,
                                  "student_sign_img",
                                  $event
                                )
                              },
                              "update:select-sign-img": function ($event) {
                                return _vm.$set(
                                  _vm.graduationRegistrationData,
                                  "student_sign_img",
                                  $event
                                )
                              },
                              selectSignImgAfter: function ($event) {
                                return _vm.studentSignImgAfter(
                                  $event,
                                  "graduationRegistrationRef",
                                  "student_sign_img"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "是否有需要学位意愿:",
                        prop: "is_degree",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.graduationRegistrationData.is_degree,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.graduationRegistrationData,
                                "is_degree",
                                $$v
                              )
                            },
                            expression: "graduationRegistrationData.is_degree",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.graduationRegistrationData.is_degree == 1
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "计算机成绩照片:",
                                prop: "computer_score_img",
                              },
                            },
                            [
                              _c("FalConUpload", {
                                ref: "uploadComputerScoreImg",
                                attrs: { limit: 1 },
                                on: {
                                  handleRemove: function ($event) {
                                    return _vm.degreeFileRemove(
                                      $event,
                                      "computer_score_img",
                                      "graduationRegistrationData"
                                    )
                                  },
                                  handleChange: function ($event) {
                                    return _vm.degreeFileChange(
                                      $event,
                                      "computer_score_img",
                                      "graduationRegistrationData"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "英语成绩照片:",
                                prop: "english_score_img",
                              },
                            },
                            [
                              _c("FalConUpload", {
                                ref: "uploadEnglishScoreImg",
                                attrs: { limit: 1 },
                                on: {
                                  handleRemove: function ($event) {
                                    return _vm.degreeFileRemove(
                                      $event,
                                      "english_score_img",
                                      "graduationRegistrationData"
                                    )
                                  },
                                  handleChange: function ($event) {
                                    return _vm.degreeFileChange(
                                      $event,
                                      "english_score_img",
                                      "graduationRegistrationData"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "平均成绩照片:",
                                prop: "average_score_img",
                              },
                            },
                            [
                              _c("FalConUpload", {
                                ref: "uploadaverageScoreImg",
                                attrs: { limit: 1 },
                                on: {
                                  handleRemove: function ($event) {
                                    return _vm.degreeFileRemove(
                                      $event,
                                      "average_score_img",
                                      "graduationRegistrationData"
                                    )
                                  },
                                  handleChange: function ($event) {
                                    return _vm.degreeFileChange(
                                      $event,
                                      "average_score_img",
                                      "graduationRegistrationData"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowGraduationRegistration = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.graduationRegistrationSubmit },
                },
                [_vm._v("确认报名")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "seeInstructor",
          attrs: {
            title: `指导教师：${_vm.studentInfo.teacher_title}`,
            visible: _vm.isShowSeeInstructor,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowSeeInstructor = $event
            },
            close: _vm.seeInstructorClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "cont" },
            [
              _c(
                "el-form",
                {
                  ref: "seeInstructorRef",
                  attrs: {
                    model: _vm.seeInstructorData,
                    rules: _vm.seeInstructorRules,
                    "label-width": "110px",
                    "label-position": "left",
                  },
                },
                [
                  _c("div", { staticClass: "floor" }, [
                    _c("div", { staticClass: "floor-title" }, [
                      _vm._v("本科毕业论文（设计）原创性声明"),
                    ]),
                    _c("div", { staticClass: "floor-text" }, [
                      _c("p", { staticClass: "text" }, [
                        _vm._v(
                          " 本人郑重声明：所提交的毕业论文（设计），是本人在导师指导下，独立进行研究工作所取得的成果。除文中已注明引用的内容外，本论文不包含任何其他个人或集体已经发表或撰写过的作品成果。对本文研究做出过重要贡献的个人和集体，均已在文中以明确方式标明。"
                        ),
                      ]),
                      _c("p", { staticClass: "text" }, [
                        _vm._v("本人完全意识到本声明的法律后果由本人承担。"),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "floor-bot" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "作者手写签名:",
                              prop: "declaration_sign_img",
                            },
                          },
                          [
                            _c("esignHandle", {
                              ref: "esignHandle1",
                              attrs: {
                                selectSignImg:
                                  _vm.seeInstructorData.declaration_sign_img,
                              },
                              on: {
                                "update:selectSignImg": function ($event) {
                                  return _vm.$set(
                                    _vm.seeInstructorData,
                                    "declaration_sign_img",
                                    $event
                                  )
                                },
                                "update:select-sign-img": function ($event) {
                                  return _vm.$set(
                                    _vm.seeInstructorData,
                                    "declaration_sign_img",
                                    $event
                                  )
                                },
                                selectSignImgAfter: function ($event) {
                                  return _vm.studentSignImgAfter(
                                    $event,
                                    "seeInstructorRef",
                                    "declaration_sign_img"
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "sign_data" } },
                          [
                            _c("div", { staticClass: "date-box" }, [
                              _c("span", { staticClass: "text value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.seeInstructorData.declarationDate.year
                                  )
                                ),
                              ]),
                              _c("span", { staticClass: "text" }, [
                                _vm._v("年"),
                              ]),
                              _c("span", { staticClass: "text value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.seeInstructorData.declarationDate.month
                                  )
                                ),
                              ]),
                              _c("span", { staticClass: "text" }, [
                                _vm._v("月"),
                              ]),
                              _c("span", { staticClass: "text value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.seeInstructorData.declarationDate.day
                                  )
                                ),
                              ]),
                              _c("span", { staticClass: "text" }, [
                                _vm._v("日"),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "floor" }, [
                    _c("div", { staticClass: "floor-title" }, [
                      _vm._v("本科毕业论文（设计）版权使用授权书"),
                    ]),
                    _c("div", { staticClass: "floor-text" }, [
                      _c("p", { staticClass: "text" }, [
                        _vm._v(
                          " 本毕业论文（设计）作者完全了解学校有关保留、使用学位论文的规定，本科生在校攻读期间毕业论文（设计）工作的知识产权单位属重庆医科大学，同意学校保留并向国家有关部门或机构送交论文的复印件和电子版，允许论文被查阅和借阅；本人授权重庆医科大学可以将毕业论文（设计）的全部或部分内容编入有关数据库进行检索，可以采用影印、缩印或扫描等复制手段保存、汇编毕业设计（论文）。。"
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "floor-bot" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "作者手写签名:",
                              prop: "authorize_sign_img",
                            },
                          },
                          [
                            _c("esignHandle", {
                              ref: "esignHandle2",
                              attrs: {
                                selectSignImg:
                                  _vm.seeInstructorData.authorize_sign_img,
                              },
                              on: {
                                "update:selectSignImg": function ($event) {
                                  return _vm.$set(
                                    _vm.seeInstructorData,
                                    "authorize_sign_img",
                                    $event
                                  )
                                },
                                "update:select-sign-img": function ($event) {
                                  return _vm.$set(
                                    _vm.seeInstructorData,
                                    "authorize_sign_img",
                                    $event
                                  )
                                },
                                selectSignImgAfter: function ($event) {
                                  return _vm.studentSignImgAfter(
                                    $event,
                                    "seeInstructorRef",
                                    "authorize_sign_img"
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "authorize_sign_data" } },
                          [
                            _c("div", { staticClass: "date-box" }, [
                              _c("span", { staticClass: "text value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.seeInstructorData.authorizeDate.year
                                  )
                                ),
                              ]),
                              _c("span", { staticClass: "text" }, [
                                _vm._v("年"),
                              ]),
                              _c("span", { staticClass: "text value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.seeInstructorData.authorizeDate.month
                                  )
                                ),
                              ]),
                              _c("span", { staticClass: "text" }, [
                                _vm._v("月"),
                              ]),
                              _c("span", { staticClass: "text value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.seeInstructorData.authorizeDate.day
                                  )
                                ),
                              ]),
                              _c("span", { staticClass: "text" }, [
                                _vm._v("日"),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "floor-bot" },
                      [
                        _c("el-form-item", {
                          attrs: { label: "导师手写签名:", prop: "" },
                        }),
                        _c(
                          "div",
                          { staticClass: "date-box" },
                          [
                            _c("el-input", {
                              staticClass: "input",
                              attrs: { readonly: "", placeholder: "" },
                              model: {
                                value: _vm.seeInstructorData.mentorDate.year,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seeInstructorData.mentorDate,
                                    "year",
                                    $$v
                                  )
                                },
                                expression: "seeInstructorData.mentorDate.year",
                              },
                            }),
                            _c("span", { staticClass: "text" }, [_vm._v("年")]),
                            _c("el-input", {
                              staticClass: "input",
                              attrs: { readonly: "", placeholder: "" },
                              model: {
                                value: _vm.seeInstructorData.mentorDate.month,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seeInstructorData.mentorDate,
                                    "month",
                                    $$v
                                  )
                                },
                                expression:
                                  "seeInstructorData.mentorDate.month",
                              },
                            }),
                            _c("span", { staticClass: "text" }, [_vm._v("月")]),
                            _c("el-input", {
                              staticClass: "input",
                              attrs: { readonly: "", placeholder: "" },
                              model: {
                                value: _vm.seeInstructorData.mentorDate.day,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seeInstructorData.mentorDate,
                                    "day",
                                    $$v
                                  )
                                },
                                expression: "seeInstructorData.mentorDate.day",
                              },
                            }),
                            _c("span", { staticClass: "text" }, [_vm._v("日")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowSeeInstructor = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.seeInstructorSubmit },
                },
                [_vm._v("确认签署")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "seeInstructor",
          attrs: {
            title: `指导教师：${_vm.studentInfo.teacher_title} 联系电话：${_vm.studentInfo.teacher_mobile}`,
            visible: _vm.isShowSeeInstructorLook,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowSeeInstructorLook = $event
            },
            close: function ($event) {
              _vm.isShowSeeInstructorLook = false
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowSeeInstructorLook = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "assignment",
          attrs: {
            title: "",
            visible: _vm.isShowAssignment,
            width: "900px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowAssignment = $event
            },
            close: _vm.assignmentClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "cont" },
            [
              _c(
                "el-form",
                {
                  ref: "assignmentRef",
                  attrs: {
                    model: _vm.assignmentData,
                    rules: _vm.assignmentRules,
                    "label-position": "left",
                  },
                },
                [
                  _c("div", { staticClass: "floor border-b" }, [
                    _c("p", { staticClass: "cont-title" }, [
                      _vm._v("重庆医科大学毕业论文（设计）任务书"),
                    ]),
                  ]),
                  _c("div", { staticClass: "floor border-b info-box" }, [
                    _c("div", { staticClass: "item border-r" }, [
                      _c("span", { staticClass: "name" }, [_vm._v("姓名：")]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.studentInfo.student_title)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item border-r" }, [
                      _c("span", { staticClass: "name" }, [_vm._v("学号：")]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.studentInfo.student_code)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v("指导教师："),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.studentInfo.teacher_title)),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title" }, [
                        _vm._v("题目："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "title" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入题目",
                              rows: 4,
                              maxlength: 500,
                              resize: "none",
                              "show-word-limit": "",
                              readonly: _vm.isShowAssignmentSubmit,
                            },
                            model: {
                              value: _vm.assignmentData.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.assignmentData, "title", $$v)
                              },
                              expression: "assignmentData.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title" }, [
                        _vm._v("主要内容："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "content" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder:
                                "备注：此处分条写明毕业设计（论文）选题的具体内容，设计类选题明确设计参数和相关指标要求。",
                              rows: 4,
                              resize: "none",
                              "show-word-limit": "",
                              readonly: _vm.isShowAssignmentSubmit,
                            },
                            model: {
                              value: _vm.assignmentData.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.assignmentData, "content", $$v)
                              },
                              expression: "assignmentData.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title" }, [
                        _vm._v("任务要求："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "requirements" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder:
                                "备注：此处分条罗列各阶段需完成的主要任务及其质量要求，包括调研、建模、分析、计算、设计、绘图等明确内容及具体要求，不能简单照搬规范要求，且明确主要任务与课程目标、毕业要求内涵观测点的支撑对应关系。",
                              rows: 4,
                              resize: "none",
                              "show-word-limit": "",
                              readonly: _vm.isShowAssignmentSubmit,
                            },
                            model: {
                              value: _vm.assignmentData.requirements,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.assignmentData,
                                  "requirements",
                                  $$v
                                )
                              },
                              expression: "assignmentData.requirements",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "floor border-b table" }, [
                    _c("p", { staticClass: "item-title" }, [
                      _vm._v("进度计划："),
                    ]),
                    _c("div", { staticClass: "table-cont" }, [
                      _c(
                        "table",
                        { staticClass: "table-box" },
                        [
                          _c("tr", [
                            _c("th", { staticClass: "cell week" }, [
                              _vm._v("周次"),
                            ]),
                            _c("th", { staticClass: "cell" }, [
                              _vm._v("主要工作计划（内容）"),
                            ]),
                            !_vm.isShowAssignmentSubmit
                              ? _c("th", { staticClass: "cell operate" }, [
                                  _vm._v("操作"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._l(
                            _vm.assignmentData.content_plan,
                            function (item, index) {
                              return _c("tr", { key: index }, [
                                _c(
                                  "td",
                                  { staticClass: "cell week" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: `content_plan.${index}.week`,
                                          rules: {
                                            required: true,
                                            message: "周次！",
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            readonly:
                                              _vm.isShowAssignmentSubmit,
                                            placeholder: "周次",
                                          },
                                          model: {
                                            value: item.week,
                                            callback: function ($$v) {
                                              _vm.$set(item, "week", $$v)
                                            },
                                            expression: "item.week",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  { staticClass: "cell cont" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: `content_plan.${index}.cont`,
                                          rules: {
                                            required: true,
                                            message: "请输入内容！",
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            readonly:
                                              _vm.isShowAssignmentSubmit,
                                            placeholder: "请输入内容",
                                            clearable: "",
                                          },
                                          model: {
                                            value: item.cont,
                                            callback: function ($$v) {
                                              _vm.$set(item, "cont", $$v)
                                            },
                                            expression: "item.cont",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                !_vm.isShowAssignmentSubmit
                                  ? _c(
                                      "td",
                                      { staticClass: "cell" },
                                      [
                                        index ==
                                        _vm.assignmentData.content_plan.length -
                                          1
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: _vm.contentPlanAdd,
                                                },
                                              },
                                              [_vm._v("添加 ")]
                                            )
                                          : _vm._e(),
                                        _vm.assignmentData.content_plan.length >
                                        1
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "danger",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.contentPlanDel(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("删除 ")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ])
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "floor bot" }, [
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "接受任务日期：",
                              "label-width": "124px",
                              prop: "accept_date",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                readonly: _vm.isShowAssignmentSubmit,
                                placeholder: "请输入接受任务日期",
                                clearable: "",
                              },
                              model: {
                                value: _vm.assignmentData.accept_date,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.assignmentData,
                                    "accept_date",
                                    $$v
                                  )
                                },
                                expression: "assignmentData.accept_date",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "要求完成日期：",
                              "label-width": "124px",
                              prop: "complete_date",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                readonly: _vm.isShowAssignmentSubmit,
                                placeholder: "请输入要求完成日期",
                                clearable: "",
                              },
                              model: {
                                value: _vm.assignmentData.complete_date,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.assignmentData,
                                    "complete_date",
                                    $$v
                                  )
                                },
                                expression: "assignmentData.complete_date",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "floor bot" }, [
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "学生接受任务（签名）:",
                              "label-width": "180px",
                              prop: "student_sign_img",
                            },
                          },
                          [
                            _vm.isShowAssignmentSubmit
                              ? _c("el-image", {
                                  staticClass: "see-img",
                                  attrs: {
                                    src: _vm.assignmentData.student_sign_img,
                                  },
                                })
                              : _c("esignHandle", {
                                  ref: "esignHandle3",
                                  attrs: {
                                    selectSignImg:
                                      _vm.assignmentData.student_sign_img,
                                  },
                                  on: {
                                    "update:selectSignImg": function ($event) {
                                      return _vm.$set(
                                        _vm.assignmentData,
                                        "student_sign_img",
                                        $event
                                      )
                                    },
                                    "update:select-sign-img": function (
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.assignmentData,
                                        "student_sign_img",
                                        $event
                                      )
                                    },
                                    selectSignImgAfter: function ($event) {
                                      return _vm.studentSignImgAfter(
                                        $event,
                                        "assignmentRef",
                                        "student_sign_img"
                                      )
                                    },
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "指导教师签名：",
                              "label-width": "124px",
                              prop: "teacher_sign_img",
                            },
                          },
                          [
                            _vm.isShowAssignmentSubmit
                              ? _c("el-image", {
                                  staticClass: "see-img",
                                  attrs: {
                                    src: _vm.assignmentData.teacher_sign_img,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowAssignment = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              !_vm.isShowAssignmentSubmit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.assignmentSubmit },
                    },
                    [_vm._v("确认提交")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "assignment",
          attrs: {
            title: "",
            visible: _vm.isShowAssignmentPDF,
            width: "900px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowAssignmentPDF = $event
            },
            close: function ($event) {
              _vm.isShowAssignmentPDF = false
            },
          },
        },
        [
          _c(
            "div",
            { ref: "assignmentRefPDF", staticClass: "assignmentPDF" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.assignmentData,
                    "label-position": "left",
                  },
                },
                [
                  _c("div", { staticClass: "floor border-b" }, [
                    _c("p", { staticClass: "cont-title" }, [
                      _vm._v("重庆医科大学毕业论文（设计）任务书"),
                    ]),
                  ]),
                  _c("div", { staticClass: "floor border-b info-box" }, [
                    _c("div", { staticClass: "item border-r" }, [
                      _c("span", { staticClass: "name" }, [_vm._v("姓名：")]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.studentInfo.student_title)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item border-r" }, [
                      _c("span", { staticClass: "name" }, [_vm._v("学号：")]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.studentInfo.student_code)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v("指导教师："),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.studentInfo.teacher_title)),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title" }, [
                        _vm._v("题目："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "title" } },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                padding: "5px 15px",
                                "white-space": "pre-wrap",
                              },
                            },
                            [_vm._v(_vm._s(_vm.assignmentData.title))]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title" }, [
                        _vm._v("主要内容："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "content" } },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                padding: "5px 15px",
                                "white-space": "pre-wrap",
                              },
                            },
                            [_vm._v(_vm._s(_vm.assignmentData.content))]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title" }, [
                        _vm._v("任务要求："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "requirements" } },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                padding: "5px 15px",
                                "white-space": "pre-wrap",
                              },
                            },
                            [_vm._v(_vm._s(_vm.assignmentData.requirements))]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "floor border-b table" }, [
                    _c("p", { staticClass: "item-title" }, [
                      _vm._v("进度计划："),
                    ]),
                    _c("div", { staticClass: "table-cont" }, [
                      _c(
                        "table",
                        { staticClass: "table-box" },
                        [
                          _c("tr", [
                            _c("th", { staticClass: "cell week" }, [
                              _vm._v("周次"),
                            ]),
                            _c("th", { staticClass: "cell" }, [
                              _vm._v("主要工作计划（内容）"),
                            ]),
                          ]),
                          _vm._l(
                            _vm.assignmentData.content_plan,
                            function (item, index) {
                              return _c("tr", { key: index }, [
                                _c("td", { staticClass: "cell week" }, [
                                  _vm._v(" " + _vm._s(item.week) + " "),
                                ]),
                                _c("td", { staticClass: "cell cont" }, [
                                  _vm._v(" " + _vm._s(item.cont) + " "),
                                ]),
                              ])
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "floor bot" }, [
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "接受任务日期：",
                              "label-width": "124px",
                              prop: "accept_date",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.assignmentData.accept_date)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "要求完成日期：",
                              "label-width": "124px",
                              prop: "complete_date",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.assignmentData.complete_date)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "floor bot" }, [
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("el-image", {
                          staticStyle: { width: "50px", height: "50px" },
                          attrs: { src: _vm.assignmentData.student_sign_img },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("el-image", {
                          staticStyle: { width: "50px", height: "50px" },
                          attrs: { src: _vm.assignmentData.teacher_sign_img },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowAssignmentPDF = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c("el-button", { on: { click: _vm.assignmentExportPDF } }, [
                _vm._v("导出PDF"),
              ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "查看任务书",
            visible: _vm.isShowAssignmentLook,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowAssignmentLook = $event
            },
            close: _vm.assignmentLookClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog" },
            _vm._l(_vm.assignmentList, function (item, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("span", [_vm._v(_vm._s(item.name))]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.downloadAssignment(item)
                        },
                      },
                    },
                    [_vm._v("下载 ")]
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowAssignmentLook = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "designData",
          attrs: {
            title:
              (_vm.designType == 1 && "一稿上传") ||
              (_vm.designType == 2 && "二稿上传") ||
              (_vm.designType == 3 && "三稿上传"),
            visible: _vm.isShowDesignData,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowDesignData = $event
            },
            close: _vm.designDataClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog" },
            [
              _c(
                "el-form",
                {
                  ref: "designDataRef",
                  attrs: {
                    model: _vm.designDataData,
                    rules: _vm.designDataRules,
                    "label-width": "200px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "设计资料文件:", prop: "files_url" } },
                    [
                      _c("FalConUpload", {
                        ref: "designDataUploadFile",
                        attrs: {
                          listStyle: "text",
                          accept:
                            ".pdf,.zip,.rar,.xls,.xlsx,.doc,.docx,.ppt,.pptx",
                          limit: 20,
                          multiple: true,
                          isFile: true,
                          isAccept: false,
                        },
                        on: {
                          handleRemove: _vm.handleRemoveFile,
                          handleChange: _vm.handleChangeFile,
                        },
                      }),
                      _c("div", { staticClass: "tips" }, [
                        _vm._v("说明：可上传PDF文档，压缩文件或OFFICE文档"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手写签名:", prop: "sign_img" } },
                    [
                      _c("esignHandle", {
                        ref: "esignHandleDesignData",
                        attrs: { selectSignImg: _vm.designDataData.sign_img },
                        on: {
                          "update:selectSignImg": function ($event) {
                            return _vm.$set(
                              _vm.designDataData,
                              "sign_img",
                              $event
                            )
                          },
                          "update:select-sign-img": function ($event) {
                            return _vm.$set(
                              _vm.designDataData,
                              "sign_img",
                              $event
                            )
                          },
                          selectSignImgAfter: function ($event) {
                            return _vm.studentSignImgAfter(
                              $event,
                              "designDataRef",
                              "sign_img"
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowDesignData = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.designDataSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }